import { atom } from "recoil";

export const addStateTargetSystem = atom({
  key: "addStateTargetSystem",
  default: false,
});
export const editStateTargetSystem = atom({
  key: "editStateTargetSystem",
  default: false,
});
export const rowEditIdStateTargetSystem = atom({
  key: "rowEditIdTargetSystem",
  default: null,
});
export const disableButtonStateTargetSystem = atom({
  key: "disableButtonTargetSystem",
  default: false,
});

export const selectedRowsStateTargetSystem = atom({
  key: "selectedRowsStateTargetSystem",
  default: [],
});

export const setFilterTextStateTargetSystem = atom({
  key: "setFilterTextStateTargetSystem",
  default: "",
});
